var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { "label-width": "0", prop: _vm.prop, rules: _vm.handleRules } },
    [
      _c(
        "el-select",
        {
          attrs: { clearable: "" },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.innerValue,
            callback: function ($$v) {
              _vm.innerValue = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "innerValue",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }